// Module
var code = "<ng-container *ngIf=\"isDashboard\">\r\n        <dashboard></dashboard>\r\n    \r\n\r\n    \r\n\r\n</ng-container>\r\n<ng-container *ngIf=\"!isDashboard\">\r\n    <qvsummary></qvsummary>\r\n</ng-container>";
// Exports
module.exports = code;